export const CANADA_CLIENT_GATEWAY_FIXED_FEES = 0.1;
export const CANADA_CLIENT_GATEWAY_VARIABLE_FEES = 1.99;

export const SAUDI_ARABIA_CLIENT_GATEWAY_FIXED_FEES = 0.2;
export const SAUDI_ARABIA_CLIENT_GATEWAY_VARIABLE_FEES = 2.9;

export const USA_CLIENT_GATEWAY_FIXED_FEES = 0.3;
export const USA_CLIENT_GATEWAY_VARIABLE_FEES = 2.9;
